import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import Loading from "./components/loading";
import {Container} from "@mui/material";
import Receipt from "./Receipt";
import Spacer from "./components/Spacer";
import Footer from "./components/home/Footer";
import ResponsiveAppBarCombined from "./components/responsive-app-bar-combined";
import ResponsiveAppBarNew from "./components/responsive-app-bar-new";

const ReceiptWrapper = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const receiptNumber = searchParams.get("receipt");
    const navigate = useNavigate();

    const [confirmed, setConfirmed] = useState(true);

    React.useEffect(() => {
        // fetch(`${determineLocation()}/billing/payment/complete/${paymentSecret}`, {method: 'POST'})
        //     .then(x => x.json().then((json)=>{
        //         if(x.status == 200){
        //             // navigate(`/receipt?receipt_id=${json.message}`)
        //
        //             window.history.replaceState(null, "Receipt", `/receipt?receipt=${json.message}`);
        //             setConfirmed(true)
        //             Store.setRenewStep(3)
        //
        //         }else{
        //             console.log("failed to get receipt");
        //         }
        //     }))
    });

    if (!confirmed) {
        return <Loading/>
    }

    return (<>
        <ResponsiveAppBarNew/>
        <Container maxWidth={"md"}>
            <Spacer height={50}/>
            <Receipt/>
        </Container>
        <Spacer height={250}/>
        <Footer/>

    </>);

}

export default ReceiptWrapper